/**
 * Configuración centralizada del modo offline.
 *
 * Define qué rutas están disponibles offline, qué acciones están
 * deshabilitadas (compras, montos), y qué tablas sincronizar.
 */

// Rutas disponibles en modo offline
export const OFFLINE_ROUTES = new Set([
  "landing",
  "terms",
  "suscripciones",
  "login",
  "register",
  "forgotPassword",
  "tambos",
  "sinAcceso",
  // Feedlot (sin compra de animales — compraAnimales excluido a propósito)
  "corralesFeedlot",
  "engorde",
  // Rodeo / Cría
  "vacas",
  "cria",
  "lotes",
  "veterinario",
  // Producción / lácteo
  "despachos",
  "empresas",
  // Alimentación
  "dietas",
  // Agricultura
  "siembras",
  "cosechas",
  "picados",
  "insumos",
  "forrajes",
  "pasturas",
  // Tareas
  "tareas",
]);

// Tablas a sincronizar con el backend vía /sync/delta
export const OFFLINE_SYNC_TABLES = [
  "animales",
  "lotes",
  "inseminaciones",
  "tactos",
  "inventario_veterinario",
  "inventario_siembra",
  "corrales_feedlot",
  "corrales_asignaciones",
  "registros_peso",
  "enfermedades_feedlot",
  "recorridos_corral",
];

/**
 * Acciones deshabilitadas offline: todo lo que involucre dinero/montos.
 * Formato: { routeName: [acciones deshabilitadas] }
 */
export const OFFLINE_DISABLED_ACTIONS = {
  engorde: [
    "compraAnimales",
    "prepararVenta",
    "confirmarVenta",
    "editarVenta",
    "cancelarVenta",
    "crearOperacionCompra",
    "actualizarPagoCompra",
  ],
  insumos: ["postCompra", "postCompraInventario", "deleteCompra"],
  veterinario: ["postCompra", "deleteCompra"],
  // Vistas habilitadas offline pero con funciones de precios desactivadas
  despachos: ["fetchPreciosReferencia", "fetchDolar"],
  empresas: ["fetchPreciosReferencia", "fetchDolar"],
  dietas: ["fetchPreciosReferencia", "fetchDolar"],
};

/**
 * Verifica si una ruta está disponible offline.
 */
export function isRouteOffline(routeName) {
  return OFFLINE_ROUTES.has(routeName);
}

/**
 * Verifica si una acción específica está deshabilitada offline
 * para una ruta determinada.
 */
export function isActionDisabledOffline(routeName, actionName) {
  const disabled = OFFLINE_DISABLED_ACTIONS[routeName];
  if (!disabled) return false;
  return disabled.includes(actionName);
}
